'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('../../../common/images/index');

var _index2 = _interopRequireDefault(_index);

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

var _ImageContainer = require('./ImageContainer');

var _ImageContainer2 = _interopRequireDefault(_ImageContainer);

var _browser = require('../../utils/services/browser');

var _toolbarConstants = require('../../workspace/toolbar/toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _index2.default)({
        presentationalComponent: _Image2.default,
        containerComponent: _ImageContainer2.default,
        tools: [_toolbarConstants.TOOLS.RICH_TEXT, _toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.CAPTION, _toolbarConstants.TOOLS.LOCK, _toolbarConstants.TOOLS.SHOW_BACKGROUND],
        tooltip: _browser.isApple ? '⌃⌘I' : 'Ctrl+Alt+I'
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/index.js
// module id = 1985
// module chunks = 0